<div class="fixed inset-0 justify-center flex items-center bg-gray-800 bg-opacity-75 z-50">
    <div class="bg-white rounded-xl p-8 w-[26rem] max-w-[92vw] shadow-2xl">

        <h2 class="text-lg font-bold text-slate-900 text-center mb-1" translate>
            ai-exam-checklist.title
        </h2>
        <p class="text-sm text-slate-500 text-center mb-6" translate>
            ai-exam-checklist.subtitle
        </p>

        <ul class="space-y-4">
            @for (stepKey of stepKeys; track stepKey; let stepIndex = $index) {
            <li class="flex items-center gap-3 checklist-step"
                [ngClass]="'checklist-step-' + stepState(stepIndex)">

                <!-- Pastille d'état : fait / en cours / à venir -->
                <span class="w-7 h-7 shrink-0 flex items-center justify-center">
                    @switch (stepState(stepIndex)) {
                    @case ('done') {
                    <mat-icon class="icon-size-6 text-green-600">check_circle</mat-icon>
                    }
                    @case ('current') {
                    <mat-spinner [diameter]="22"></mat-spinner>
                    }
                    @default {
                    <span class="w-2.5 h-2.5 rounded-full bg-gray-300"></span>
                    }
                    }
                </span>

                <span class="text-slate-700"
                      [ngClass]="{
                          'font-medium': stepState(stepIndex) === 'current',
                          'text-slate-400': stepState(stepIndex) === 'pending'
                      }" translate>
                    {{ stepKey }}
                </span>
            </li>
            }
        </ul>
    </div>
</div>
